import { useLayoutEffect, useRef, useState } from 'react';

// A fixed header is independent of #root's horizontal overflow scroll container.
// Reserve its measured height so wrapping text and safe-area insets never cover content.
export default function VipPageHeader({ children }) {
  const header = useRef(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const measure = () => {
      const next = Math.ceil(header.current?.getBoundingClientRect().height || 0);
      if (next > 0) setHeight(previous => previous === next ? previous : next);
    };
    measure();
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    if (header.current) observer?.observe(header.current);
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  return <div className="vip-header-slot" style={height ? { height } : undefined}>
    <header className="vip-header" ref={header}>{children}</header>
  </div>;
}

